import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var MarkupIcon64Regular = forwardRefAndName('MarkupIcon64Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 64
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M27.5607 27.9393C28.1465 28.5251 28.1465 29.4748 27.5607 30.0606L22.3285 35.2928C21.9379 35.6834 21.9379 36.3165 22.3285 36.707L27.5607 41.9393C28.1465 42.5251 28.1465 43.4748 27.5607 44.0606C26.9749 44.6464 26.0252 44.6464 25.4394 44.0606L20.2071 38.8284C18.645 37.2663 18.645 34.7336 20.2071 33.1715L25.4394 27.9393C26.0252 27.3535 26.9749 27.3535 27.5607 27.9393Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M36.4394 30.0606C35.8536 29.4748 35.8536 28.5251 36.4394 27.9393C37.0252 27.3535 37.9749 27.3535 38.5607 27.9393L43.7929 33.1715C45.355 34.7336 45.355 37.2663 43.7929 38.8284L38.5607 44.0606C37.9749 44.6464 37.0252 44.6464 36.4394 44.0606C35.8536 43.4748 35.8536 42.5251 36.4394 41.9393L41.6716 36.707C42.0621 36.3165 42.0621 35.6834 41.6716 35.2928L36.4394 30.0606Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 16.5C11 10.701 15.701 6 21.5 6H35.9522C37.9413 6 39.8489 6.79017 41.2555 8.1967L50.8033 17.7445C52.2098 19.1511 53 21.0587 53 23.0478V47.5C53 53.299 48.299 58 42.5 58H21.5C15.701 58 11 53.299 11 47.5V16.5ZM21.5 9C17.3579 9 14 12.3579 14 16.5V47.5C14 51.6421 17.3579 55 21.5 55H42.5C46.6421 55 50 51.6421 50 47.5V23.0478C50 21.8544 49.5259 20.7098 48.682 19.8659L39.1341 10.318C38.2902 9.4741 37.1456 9 35.9522 9H21.5Z"
    }))
  );
});